/* eslint-disable eqeqeq */
import { Sticky, StickyContainer } from "react-sticky";
import { BasePage } from "../../../../framework/pages/BasePage";
import { Tabs } from "antd";
import ConfigurarPuntosSection from "../../tabs/ConfigurarPuntosSection";
import ProcedenciaMuestraModal from "../../tabs/ProcedenciaMuestraModal";
import EquiposUtilizadosModal from "../../tabs/EquiposUtilizadosModal";
import OtrosDatosModal from "../../tabs/OtrosDatosModal";
import DatosServisiosModal from "../../tabs/DatosServisiosModal";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";
import { DATE_FORMAT, PAGE_MODE } from "../../../../constants/constants";
import { DetalleMuestreoModal } from "../../tabs/DetalleMuestreoModal";
import { ModalContext } from "../../../../provider/ModalProvider";
import { COLUMN_DEFAULT } from "../../../../framework/grid/GridFw";
import { SubparametrosResultadosAireModal } from "./SubparametroResultadosAireModal";
import { DetalleEstacionAireModal } from "./DetalleEstacionAireModal";
import { AgregarEstacionModal } from "../../../servicios-ejecutados/tabs/PlanificacionSejecutados/modals/AgregarEstacionModal";
import { EditarEstacionModal } from "../../../servicios-ejecutados/tabs/PlanificacionSejecutados/modals/EditarEstacionModal";
import { MessageUtil } from "../../../../util/MessageUtil";
import { LoadUtil } from "../../../../framework/util/LoadUtil";
import { RequestUtil } from "../../../../util/RequestUtil";
import { EnvConstants } from "../../../../EnvConstants";

class CadenaAirePage extends BasePage {
  static contextType = ModalContext;

  constructor(props) {
    super(props);
    this.state = {
      id_doc: null,
      keyPanel: "1",
    };
    this.cambiarTabPanel = this.cambiarTabPanel.bind(this);
  }

  cambiarTabPanel(tab, id_doc) {
    this.setState({
      id_doc: id_doc,
      keyPanel: tab,
      keyPrincipal: tab,
    });
  }

  renderPage(pageApi, keyPanel) {
    const getgrid_detalle_muestreo = () =>
      pageApi.getComponent("gridDetalleMuestreo");
    const getform_detalle_muestreo = () =>
      pageApi.getComponent("formDetalleMuestreo");
    const { TabPane } = Tabs;

    const ConfiguracionModalConfig = (data) => {
      const { showModal, hideModal } = this.context;
      let obj = {};
      obj = { ...obj, hideModal, data };

      showModal({
        width: 800,
        maskClosable: false,
        component: (
          <SubparametrosResultadosAireModal
            name={obj}
            getParentApi={pageApi.getApi}
          />
        ),
      });
    };

    const fnUpdateItem = (data) => {
      this.context.hideModal();
      getform_detalle_muestreo().setFieldData("id_estacion", data.id_estacion);
      getform_detalle_muestreo().setFieldData(
        "desc_estacion",
        data.DESCRIPCION,
      );
      getform_detalle_muestreo().setFieldData(
        "geo_estacion",
        `E: ${data?.COORDF || "0"}, - ,N:  ${data?.COORDN || "0"}`,
      );
      getform_detalle_muestreo().setFieldData("alt_estacion", data.ALTITUD);
      getform_detalle_muestreo().setFieldData("zona_estacion", data.ZONA);
    };

    const ConfigEstacionModal = (data, esNuevo = true, id_estacion = 0) => {
      const { showModal } = this.context;
      let obj = {};

      obj = {
        fnUpdateItem,
        data: {
          ...data,
          id_tipo_matriz: pageApi.name?.id_tipo_matriz,
          id_empresa: pageApi.name?.id_empresa,
          id_estacion: id_estacion,
        },
      };

      showModal({
        title: esNuevo ? "Agregar Estación" : "Editar Estación",
        width: 350,
        maskClosable: true,
        closable: false,
        background: "white",
        component: esNuevo ? (
          <AgregarEstacionModal name={obj} getParentApi={pageApi.getApi} />
        ) : (
          <EditarEstacionModal name={obj} getParentApi={pageApi.getApi} />
        ),
      });
    };

    const DetalleMuestreoModalConfig = (data) => {
      const { showModal, hideModal } = this.context;
      let obj = {};
      obj = {
        ...obj,
        hideModal,
        data,
      };

      showModal({
        width: 1500,
        maskClosable: false,
        component: (
          <DetalleEstacionAireModal name={obj} getParentApi={pageApi.getApi} />
        ),
      });
    };

    const formDetalleMuestreo = (pageApi) => {
      let id_estacion_previo = 0;

      return {
        title: "Estación Muestra",
        layout: "vertical",
        autoLoad: true,
        load: {
          queryId: 940,
          params: {
            id_cadena: pageApi.getParamId(),
          },
          hideMessage: true,
          hideMessageError: true,
        },
        save: {
          queryId: 939,
          params: {
            id_cadena: pageApi.getParamId(),
          },
          fnOk: () => {
            getform_detalle_muestreo().load();
          },
          hideMessage: true,
          hideMessageError: true,
        },
        fields: [
          {
            type: "select",
            name: "id_estacion",
            label: "Estación",
            search: true,
            column: 4,
            // labelName: 'estaciondes', label: 'Estación',
            load: {
              queryId: 846,
              params: () => {
                return {
                  id_empresa: pageApi.name?.id_empresa,
                  id_tipo_matriz: pageApi.name?.id_tipo_matriz,
                };
              },
            },
            onChange: async (value, values, formApi) => {
              if (value == 0) {
                ConfigEstacionModal(formApi.getData(), true);
                formApi.setFieldData("id_estacion", null);
                formApi.setFieldData("descripcion", null);
                formApi.setFieldData("COORDF", null);
                formApi.setFieldData("COORDN", null);
                id_estacion_previo = 0;
              } else if (value == -1) {
                const estaciones = formApi?.getFieldApi("id_estacion").dataList;
                const estacionPrevio = estaciones.find(
                  (el) => el?.id_estacion === id_estacion_previo,
                );
                let id_estacion = estacionPrevio?.id_estacion;

                if (!id_estacion) {
                  formApi.setFieldData("id_estacion", null);
                  formApi.setFieldData("desc_estacion", null);
                  formApi.setFieldData("geo_estacion", null);
                  formApi.setFieldData("alt_estacion", null);
                  formApi.setFieldData("zona_estacion", null);
                  return MessageUtil(
                    "warning",
                    "Advertencia",
                    "Debe seleccionar primero una estaciòn para poder editar.",
                  );
                }

                formApi.setFieldData("id_estacion", estacionPrevio.id_estacion);
                ConfigEstacionModal(
                  { ...estacionPrevio, id_estacion },
                  false,
                  id_estacion,
                );
                id_estacion_previo = id_estacion;
              } else {
                const id_estacion = value;

                const reqParams = LoadUtil.getReqParams({
                  queryId: 138,
                  params: {
                    ID_ESTACION: id_estacion,
                  },
                });

                const data = await RequestUtil.postData(
                  EnvConstants.GET_URL_READ(),
                  reqParams,
                )
                  .then((resp) => resp.dataObject)
                  .catch(() => []);

                let descripcion = data?.DESCRIPCION;
                let georeferencia = `E: ${data?.COORDF || "0"}, - ,N:  ${data?.COORDN || "0"}`;
                let altitud = data?.ALTITUD;
                let zona = data?.ZONA;

                formApi.setFieldData("id_estacion", value);
                formApi.setFieldData("desc_estacion", descripcion);
                formApi.setFieldData("geo_estacion", georeferencia);
                formApi.setFieldData("alt_estacion", altitud);
                formApi.setFieldData("zona_estacion", zona);
                id_estacion_previo = value;
              }
            },
          },
          {
            name: "desc_estacion",
            label: "Descripción",
            column: 4,
            readOnly: true,
          },
          {
            name: "geo_estacion",
            label: "Georeferencia",
            column: 4,
            readOnly: true,
          },
          { name: "alt_estacion", label: "Altitud", column: 4, readOnly: true },
          { name: "zona_estacion", label: "Zona", column: 4, readOnly: true },
        ],
      };
    };

    const formCondicionesAmbientales = (pageApi) => ({
      title: "Condiciones Ambientales",
      layout: "vertical",
      autoLoad: true,
      load: {
        queryId: 354,
        params: { ID_CADENA: pageApi.getParamId() },
        fnOk: (resp) => {},
      },
      save: {
        queryId: 931,
        hideMessage: true,
        hideMessageError: true,
      },
      fields: [
        { name: "T_ATM_INICIAL", label: "T° Atmosférica Inicial", column: 4 },
        {
          name: "P_ATM_INICIAL",
          label: "Presión Atmosférica Inicial",
          column: 4,
        },
        { name: "H_REL_INICIAL", label: "Humedad Relativa Inicial", column: 4 },
        { name: "T_ATM_FINAL", label: "T° Atmosférica Final", column: 4 },
        { name: "P_ATM_FINAL", label: "Presión Atmosférica Final", column: 4 },
        { name: "H_REL_FINAL", label: "Humedad Relativa Finial", column: 4 },
      ],
    });

    const gridDetalleMuestreo = (pageApi) => ({
      title: "Detalles de Muestreo",
      showIndex: true,
      autoLoad: true,
      pagination: {
        server: false,
        showSizeChanger: true,
      },
      rowId: "ID_PARAMETRO",
      load: {
        validation: () => pageApi.getParamId() != null,
        queryId: 926,
        params: () => {
          return {
            ID_CADENA: pageApi.getParamId(),
          };
        },
        hideMessage: true,
        hideMessageError: true,
      },
      save: {
        queryId: 932,
        hideMessage: true,
        hideMessageError: true,
        fnOk: () => {
          getgrid_detalle_muestreo().load();
        },
      },
      fields: [
        { name: "MUESTRA", label: "Cod. Muestra" },
        {
          type: "date",
          name: "FECHA_INICIAL",
          label: "Fecha Inicio",
          editable: true,
          format: "DD/MM/YYYY",
          inputFormat: DATE_FORMAT.YYYYMMDD,
        },
        {
          type: "date",
          name: "HORA_INICIAL",
          label: "Hora Inicio",
          editable: true,
          format: DATE_FORMAT.HHmm,
          inputFormat: DATE_FORMAT.HHmm,
        },
        {
          type: "date",
          name: "FECHA_FIN",
          label: "Fecha Fin",
          editable: true,
          format: "DD/MM/YYYY",
          inputFormat: DATE_FORMAT.YYYYMMDD,
        },
        {
          type: "date",
          name: "HORA_FIN",
          label: "Hora Fin",
          editable: true,
          format: DATE_FORMAT.HHmm,
          inputFormat: DATE_FORMAT.HHmm,
        },
        { name: "CODIGO", label: "Código de Filtro", editable: true },
        {
          type: "number",
          name: "TIEMPO",
          label: "Tiempo total",
          editable: true,
        },
        {
          type: "select",
          name: "EQUIPO_AUTOMATICO",
          label: "Equipo Automático",
          labelName: "EQUIPODES",
          load: { queryId: 390 },
          editable: true,
        },
        {
          name: "H_INICIAL",
          label: "△Inicio",
          format: DATE_FORMAT.HHmm,
          inputFormat: DATE_FORMAT.HHmm,
          editable: true,
        },
        {
          name: "H_FINAL",
          format: DATE_FORMAT.HHmm,
          inputFormat: DATE_FORMAT.HHmm,
          label: "△Final",
          editable: true,
        },
        { name: "H_PROMEDIO", label: "△Promedio", editable: true },
        {
          type: "select",
          name: "RECEPCION",
          label: "Recepción Conforme",
          labelName: "RECEPCIONDES",
          load: { queryId: 390 },
          editable: true,
        },
        { name: "OBS", label: "Observación", editable: true },
        { name: "PARAMETRO", label: "Parametro" },
        {
          ...COLUMN_DEFAULT.OPTIONS,
          label: "Opciones",
          title: "Ingresar Resultados",
          color: "blue",
          colSpan: 2,
          onClick: (value, row) => {
            ConfiguracionModalConfig(row);
          },
          fnVisible: (value, row, index) => {
            return row?.tec_id == 18;
          },
        },
        {
          ...COLUMN_DEFAULT.SYNC,
          title: "Detalle del muestreo",
          color: "blue",
          onClick: (value, row) => {
            DetalleMuestreoModalConfig({
              ...row,
              ID_IA: pageApi.name?.id_ia,
              ID_PARAMETRO: row.ID_PARAMETRO,
              ID_CADENA: pageApi.getParamId(),
              getGrid: () => getgrid_detalle_muestreo(),
            });
          },
          fnVisible: (value, row, index) => {
            return true;
          },
        },
      ],
      onComponentLoad: (formApi, pageApi) => {
        if (pageApi.getPageMode() !== PAGE_MODE.NEW) formApi.load();
      },
    });

    const renderTabBar = (props, DefaultTabBar) => (
      <Sticky bottomOffset={80}>
        {({ style }) => (
          <DefaultTabBar
            {...props}
            className="site-custom-tab-bar"
            style={style}
          />
        )}
      </Sticky>
    );

    const gridsConfigDetalleMuestreo = [
      {
        name: "formCondicionesAmbientales",
        config: formCondicionesAmbientales(pageApi),
        type: "form",
      },
      {
        name: "formDetalleMuestreo",
        config: formDetalleMuestreo(pageApi),
        type: "form",
      },
      {
        name: "gridDetalleMuestreo",
        config: gridDetalleMuestreo(pageApi),
        type: "grid",
      },
    ];

    return (
      <StickyContainer>
        <Tabs
          destroyInactiveTabPane={true}
          activeKey={this.state.keyPanel}
          renderTabBar={renderTabBar}
          onChange={(key) => this.setState({ keyPanel: key })}
        >
          <TabPane tab="Configurar Puntos" key="1">
            <ConfigurarPuntosSection
              api={pageApi}
              name={{...pageApi.name}}
              cambiarTabPanel={this.cambiarTabPanel}
              history={this.props.history}
            />
          </TabPane>

          <TabPane
            tab="Datos del Servicio"
            key="2"
            disabled={parseInt(pageApi.getParamId()) === 0 ? true : false}
          >
            <DatosServisiosModal
              api={pageApi}
              name={{...pageApi.name}}
              cambiarTabPanel={this.cambiarTabPanel}
              history={this.props.history}
            />
          </TabPane>

          <TabPane
            tab="Procedencia de la muestra"
            key="3"
            disabled={parseInt(pageApi.getParamId()) === 0 ? true : false}
          >
            <ProcedenciaMuestraModal
              api={pageApi}
              name={{...pageApi.name}}
              cambiarTabPanel={this.cambiarTabPanel}
              history={this.props.history}
            />
          </TabPane>

          <TabPane
            tab="Detalle del muestreo"
            key="4"
            disabled={parseInt(pageApi.getParamId()) === 0 ? true : false}
          >
            <DetalleMuestreoModal
              api={pageApi}
              data={{ ...pageApi.name }}
              cambiarTabPanel={this.cambiarTabPanel}
              history={this.props.history}
              gridsConfig={gridsConfigDetalleMuestreo}
            />
          </TabPane>

          <TabPane
            tab="Equipos Utilizados"
            key="5"
            disabled={parseInt(pageApi.getParamId()) === 0 ? true : false}
          >
            <EquiposUtilizadosModal
              api={pageApi}
              name={{...pageApi.name}}
              cambiarTabPanel={this.cambiarTabPanel}
              history={this.props.history}
            />
          </TabPane>

          <TabPane
            tab="Otros Datos"
            key="6"
            disabled={parseInt(pageApi.getParamId()) === 0 ? true : false}
          >
            <OtrosDatosModal
              api={pageApi}
              name={{...pageApi.name}}
              cambiarTabPanel={this.cambiarTabPanel}
              history={this.props.history}
            />
          </TabPane>
        </Tabs>
      </StickyContainer>
    );
  }
}

export default withRouter(CadenaAirePage);
